import { SCREENS } from "utils/constants";
import Container from "shared/components/Container";
import { Link } from "react-router-dom";
import Tokens from "./Tokens";

function Settings() {
  return (
    <Container>
      <Link to={SCREENS.PRIVATE.SHARED.TOKENS.path}>Tokens</Link>
    </Container>
  );
}

const routes = [
  {
    path: SCREENS.PRIVATE.SHARED.TOKENS.path,
    exact: true,
    element: <Tokens />,
  },
  {
    path: SCREENS.PRIVATE.SHARED.SETTINGS.path,
    exact: true,
    element: <Settings />,
  },
];

export default routes;
